/* istanbul ignore file
 *
 * framework test cases are tested in platform only so excluding here */
import { applyMiddleware, compose, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';

const loggerMiddleware = createLogger();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

/**
 * createstore with middleware
 */

const configureStore = (combinedReducers, preState, middlewares) => {
  if (process.env.NODE_ENV === 'test') {
    return createStore(combinedReducers, preState, composeEnhancers(applyMiddleware(...middlewares, thunk)));
  }

  if (process.env.NODE_ENV === 'development') {
    return createStore(
      combinedReducers,
      preState,
      composeEnhancers(applyMiddleware(...middlewares, loggerMiddleware, thunk))
    );
  }
  return createStore(combinedReducers, preState, composeEnhancers(applyMiddleware(...middlewares, thunk)));
};

export default configureStore;
